import * as service from "../service";
import { store } from "../../store";
import { controlLoading } from "../../slices/app.slice";

/**
 * Get all sponsor_task_completions for sponsors owned by a user.
 * The backend groups the completions by sponsor + student and paginates the
 * raw completions (10 per page).
 * Backend: GET /api/sponsor/sponsorOwnerCompletions/:userId?page=1
 */
export const getSponsorOwnerCompletionsAPI = async (page?: number) => {
  const { business } = store.getState().auth;
  try {
    store.dispatch(controlLoading({ showLoading: true }));
    const resp = await service.call(
      "GET",
      `/api/sponsor/sponsorOwnerCompletions/${encodeURIComponent(business?.user_id)}`,
      page !== undefined ? { page } : {},
    );
    store.dispatch(controlLoading({ showLoading: false }));
    return resp;
  } catch (err) {
    store.dispatch(controlLoading({ showLoading: false }));
    console.error(`getSponsorOwnerCompletionsAPI ${err}`);
    throw err;
  }
};

/**
 * Approve or reject a sponsor task completion.
 * Usage: await approveOrRejectSponsorTaskCompletion({ completionId, approve, failReason?, userId? })
 * Backend: POST /api/sponsor/sponsorOwnerCompletions/approve-or-reject
 */
export const approveOrRejectSponsorTaskCompletion = async (params: any) => {
  const { completionId, approve, failReason, userId } = params;
  const { business } = store.getState().auth;
  const resolvedUserId = userId || business?.user_id;
  try {
    store.dispatch(controlLoading({ showLoading: true }));
    const body =
      failReason !== undefined && failReason !== null
        ? { completionId, approve, failReason, userId: resolvedUserId }
        : { completionId, approve, userId: resolvedUserId };
    const resp = await service.call(
      "POST",
      "/api/sponsor/sponsorOwnerCompletions/approve-or-reject",
      body,
    );
    store.dispatch(controlLoading({ showLoading: false }));
    return resp;
  } catch (err) {
    store.dispatch(controlLoading({ showLoading: false }));
    console.error(`approveOrRejectSponsorTaskCompletion ${err}`);
    throw err;
  }
};